const module = [
  {
    id: '46d2deec-deb2-4b52-af9d-07b127577d7f',
    slug: 'benefits-of-meeting-existing-clients-needs',
    visible: true,
    requiresAuth: false,
    showFeedbackForm: true,
    concatenatedID: '46d2deec-deb2-4b52-af9d-07b127577d7f|3187c558-5836-4721-a158-776c11b266ee',
    template: 'video-template',
    title: 'Benefits of meeting existing clients needs',
    description:
      'You’ll learn why it’s beneficial to offer a comprehensive solution to your existing clients to meet their cover needs.',
    completedDescription: 'TODO',
    supplier: 'Nick Thomas Associates',
    categoryId: '3187c558-5836-4721-a158-776c11b266ee',
    questionnaireId: '',
    contents: {
      id: '109fcaf5-af07-4ca0-900d-cfce58aea224',
      longDescription:
        '<h2 class="subtitle">Description</h2>' +
        'Using a consultative approach to understand prospect needs and developing specific solutions to meet these needs.' +
        '<h2 class="subtitle">Objectives</h2>' +
        '<ul style="margin-top:10px">' +
        '<li>Key benefits of addressing client needs</li>' +
        '<li>Benefits to the client</li>' +
        '<li>Benefits to the broker</li>' +
        '<li>Any disadvantages to offering existing clients new products and services</li>' +
        '</ul>',
      heroImage: false,
      media: [
        {
          type: 'video',
          subType: 'vimeo',
          title: 'Benefits of meeting existing clients needs',
          button: '',
          fileSize: 0,
          url: 'https://player.vimeo.com/video/798325204',
          caption: {
            title: '',
            description:
              '<p>Delivered by: Nick Thomas</p>' +
              '<p>Brought to you by: Nick Thomas & Associates (specialist coaching, training and consulting to the UK insurance sector), on behalf of AXA Commercial.</p>'
          }
        },
        {
          type: 'file',
          subType: 'pdf',
          title: 'Benefits of meeting existing clients needs',
          button: 'Download Slides',
          fileSize: '1200754',
          url: 'addressing_the_needs_of_existing_clients.pdf',
          caption: {
            title: '',
            description: ''
          },
          axaUrl: ''
        }
      ]
    },
    progress: {
      value: 1,
      maximum: 3
    },
    statistics: {
      level: 1,
      timeEstimate: '5'
    },
    status: {
      state: 'not-started',
      completedDate: ''
    },
    tags: ['marketing', 'sales', 'skills', 'intermediate']
  }
];

export const AddressingTheNeedsOfExistingClientsForWinWinResults = {
  module
};
